












































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'

import userList from '@/store/entities/userinfo'
import Enums from '@/lib/enums'
import appconst from '@/lib/appconst';
class Packed {
    Id: null;
    //shelfPosition: string;
    //productName: string;
    purchaseCost: number;
}
@Component
export default class EditShilfPositionModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    selectuser: userList = new userList();
    user: Array<userList> = [];
    automaticJump: boolean;
    PackedModel: Packed = new Packed();

    created() {

    }


    async check() {
        (this.$refs.packForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.PackedModel.Id = this.$store.state.frontstockproduct.id;
                await this.$store.dispatch({
                    type: 'frontstockproduct/EditStockProduct',
                    data: this.PackedModel
                });
                (this.$refs.packForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            }
        })
        
    }


    cancel() {
        (this.$refs.packForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            this.$set(this.PackedModel, "purchaseCost", this.$store.state.frontstockproduct.purchaseCost);
            this.$set(this.PackedModel, "productSku", this.$store.state.frontstockproduct.productSku);
            this.$set(this.PackedModel, "productName", this.$store.state.frontstockproduct.productName);
            this.$set(this.PackedModel, "platformInfo", this.$store.state.frontstockproduct.platformInfo);
        }
    }
    //costRule = {
    //    shelfPosition: [
    //        { required: true, message: '货架号不能为空', trigger: 'blur' }
    //    ],
    //    productName: [
    //        { required: true, message: '产品名称不能为空', trigger: 'blur' }
    //    ],
    //};
}
